/**
 * Derive enabled spine stages from definition content (not author checkboxes).
 *
 * Ground + Analyze + Explain are the Decision-agent default.
 * Generate/Act turns on when Output expected suggests an operational artifact.
 * Remember / Promote stay off unless an explicit policy toggle is added later —
 * they are write-side gates, not inferred from prose.
 */

import type { ExpectedFieldRow, StudioSpineStage } from '@/types/aiStudioAgent';

const ARTIFACT_HINT =
  /\b(schedule|reschedule|re-?plan|sequenc|gantt|dispatch|roster|timetable|work.?plan|operational artifact)\b/i;

export function deriveEnabledStages(outputExpected: ExpectedFieldRow[]): StudioSpineStage[] {
  const stages: StudioSpineStage[] = ['ground', 'analyze', 'explain'];
  const blob = outputExpected
    .map((row) => `${row.label} ${row.description}`)
    .join(' ');
  if (ARTIFACT_HINT.test(blob)) {
    stages.splice(2, 0, 'generate_act'); // after analyze
  }
  return stages;
}
